import api from '@app/utils/api';
import qs from 'qs';

export const createActivity = (body) => {
  return api.post(`/activities`, body);
};

export const updateActivity = (entityId, body) => {
  return api.put(`/activities`, body);
};

export const fetchEntities = (params) => {
  const qParams = qs.stringify(params);
  return api.get(`/executive/entities?${qParams}`);
};

export const fetchActivities = (params) => {
  const qParams = qs.stringify(params);
  return api.get(`/activities?${qParams}`);
};

export const fetchActivity = (params) => {
  return api.get(`/executive/activities/get?${qs.stringify(params)}`);
};

export const fetchSourceCategories = (params) => {
  const qParams = qs.stringify(params);
  return api.get(`/calc-engine/source-categories?${qParams}`);
};

export const fetchCategorySources = (categoryId, params) => {
  const qParams = qs.stringify(params);
  return api.get(`/calc-engine/source-categories/${categoryId}?${qParams}`);
};

export const fetchSourceData = (categoryId, sourceId, params) => {
  const qParams = qs.stringify(params);
  return api.get(
    `/calc-engine/source-categories/${categoryId}/source-data/${sourceId}?${qParams}`
  );
};
